// src/services/locationServicesPublic.js
import api from "../api/api"; // ✅ তোমার দেওয়া public axios instance

// ✅ Backend origin (storage url বানাতে লাগবে)
const ORIGIN = import.meta.env?.VITE_BACKEND_ORIGIN || "https://api.ifjona.com";

// ✅ "/storage/...." বা "locations/flags/..." যাই আসুক, full url বানাবে
const toStorageUrl = (path) => {
  if (!path) return null;
  const s = String(path);

  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  if (s.startsWith("/storage/")) return `${ORIGIN}${s}`;
  if (s.startsWith("storage/")) return `${ORIGIN}/${s}`;
  if (s.startsWith("/")) return `${ORIGIN}${s}`;
  return `${ORIGIN}/storage/${s}`;
};

// ✅ Public endpoint: Route::get('/locations', ...)
export const getLocations = async () => {
  const res = await api.get("/locations");

  // supports: {data:[...]} OR [...]
  const list = Array.isArray(res?.data?.data)
    ? res.data.data
    : Array.isArray(res?.data)
    ? res.data
    : [];

  // ✅ only active + map to Header format
  return (list || [])
    .filter((x) => Number(x?.is_active) === 1)
    .sort((a, b) => Number(a?.sort_order || 0) - Number(b?.sort_order || 0))
    .map((x) => ({
      name: x?.name,
      flag: toStorageUrl(x?.flag_url || x?.flag), // backend flag_url থাকলে সেটাই prefer
    }));
};
